// extracted by mini-css-extract-plugin
export var errorMessage = "StatusMessage-module--error-message--fb476";
export var successMessage = "StatusMessage-module--success-message--86764";